module.exports = __webpack_public_path__ + "img/close-square.b9cf6b6f.svg";